// Grupos primários normalizados — sem compostos
export const MUSCLE_GROUP_OPTIONS = [
  // Superiores
  { value: "peito",       label: "Peito" },
  { value: "costas",      label: "Costas" },
  { value: "ombros",      label: "Ombros" },
  { value: "trapezio",    label: "Trapézio" },
  { value: "biceps",      label: "Bíceps" },
  { value: "triceps",     label: "Tríceps" },
  { value: "antebraco",   label: "Antebraço" },

  // Inferiores
  { value: "quadriceps",    label: "Quadríceps" },
  { value: "posterior_coxa", label: "Posterior de coxa" },
  { value: "gluteos",       label: "Glúteos" },
  { value: "adutores",      label: "Adutores" },
  { value: "panturrilhas",  label: "Panturrilhas" },

  // Outros
  { value: "core",          label: "Core" },
  { value: "cardio",        label: "Cardio" },
  { value: "obliquos",       label: "Oblíquos" },
  
];
  
  export const EQUIPMENT_OPTIONS = [
    { value: "peso_corporal", label: "Peso corporal" },
  
    { value: "barra", label: "Barra" },
    { value: "barra_fixa", label: "Barra fixa" },
    { value: "barra_tbar", label: "Barra / T-bar" },
    { value: "barra_maquina", label: "Barra / Maquina" },
  
    { value: "halter", label: "Halter" },
    { value: "halteres", label: "Halteres" },
  
    { value: "paralelas", label: "Paralelas" },
    { value: "banco", label: "Banco" },
    { value: "banco_halteres", label: "Banco / Halteres" },
    { value: "banco_peso_corporal", label: "Banco / Peso corporal" },
    { value: "caixote", label: "Caixote" },
  
    { value: "corda", label: "Corda" },
    { value: "corda_naval", label: "Corda naval" },
    { value: "corda_polia", label: "Corda / Polia" },
  
    { value: "cross", label: "Cross" },
    { value: "polia", label: "Polia" },
    { value: "maquina", label: "Maquina" },
    { value: "smith", label: "Smith" },
    { value: "leg_press", label: "Leg press" },
  
    { value: "bicicleta", label: "Bicicleta" },
    { value: "esteira", label: "Esteira" },
    { value: "eliptico", label: "Eliptico" },
    { value: "escada", label: "Escada" },
    { value: "remo_ergometrico", label: "Remo ergometrico" },
    { value: "air_bike", label: "Air bike" },
    { value: "ski_erg", label: "Ski erg" },
  
    { value: "miniband", label: "Miniband" },
    { value: "trap_bar", label: "Trap bar" },
    { value: "livre", label: "Livre" },
  ];
  
  export const MOVEMENT_TYPE_OPTIONS = [
    { value: "forca", label: "Forca" },
    { value: "cardio", label: "Cardio" },
    { value: "core", label: "Core" },
  ];
  
  export function getOptionLabel(options, value) {
    return options.find((opt) => opt.value === value)?.label || value || "";
  }
  
  export function normalizeOptionValue(value = "") {
    return value
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[\s/-]+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "");
  }